
<div class="basket-summary-row">
	<div class="_title">{{'TO.total-items' | translate}}</div>
	<div class="_price text-highlight">{{$storage.order.total | lcurrency}}</div>
</div>

<div style="font-size:0.85em">
	@if ($storage.order.promotion?.calc?.amount) {
	<div class="basket-summary-row">
		<mat-icon class="" svgIcon="badge_percent"></mat-icon>
		<div class="_title">{{$storage.order.promotion.title}}</div>
		<div class="_price text-price-negative text-highlight">{{$storage.order.promotion.calc.amount | lcurrency:'0.2-2'}}</div>
	</div>
	}


	@if (loyaltyService.loyaltyData) {
		@if (loyaltyService.loyaltyData.hasBenefits && loyaltyService.loyaltyData?.orderBenefits?.byBenefits) {
			@for (benefit of loyaltyService.loyaltyData.orderBenefits.byBenefits; track benefit) {
				<div class="basket-summary-row">
					<mat-icon svgIcon="loyalty_benefit"></mat-icon>
					<div class="_title">{{benefit.name}}</div>
					<div class="_price text-price-negative text-highlight">{{benefit.value | lcurrency:'0.2-2'}}</div>
				</div>
			}
		}
		@if (loyaltyService.loyaltyData.pointsUsed) {
			<div class="basket-summary-row">
				<mat-icon svgIcon="loyalty_benefit"></mat-icon>
				<div class="_title">{{'_LOYALTY.review_points' | translate}}</div>
				<div class="_price text-price-negative text-highlight">{{loyaltyService.loyaltyData.pointsUsed | lcurrency:'0.2-2'}}</div>
			</div>
		}
	}

	@if ($storage.order.taxAndFees?.fees) {
	<div class="basket-summary-row">
		<div class="_title">{{'TO.fees' | translate}}</div>
		<div class="_price text-highlight">{{$storage.order.taxAndFees.fees | lcurrency}}</div>
	</div>
	}
	@if ($storage.order.taxAndFees?.tax) {
		<div class="basket-summary-row">
			<div class="_title">{{ 'TO.tax' | translate }}</div>
			<div class="_price text-highlight">{{ $storage.order.taxAndFees.tax | lcurrency }}</div>
		</div>
	}

	@if ($storage.gratuity?.amount) {
	<div class="basket-summary-row">
		<div class="_title">{{'TO.tip' | translate}}</div>
		<div class="_price text-highlight">{{$storage.gratuity.amount | lcurrency}}</div>
	</div>
	}
</div>
@if (!options.isInSummary) {
<div class="basket-summary-row">
	<div class="_title">{{'TO.total-to-pay' | translate}}</div>
	<div class="_price text-highlight">{{($storage.order.realGrandTotal || $storage.order.grandTotal) | lcurrency}}</div>
</div>
}

